import { Injectable } from '@angular/core';
import moment from 'moment';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { FocuslinkService } from './focuslink.service';
import { OOVenueService } from './venue-service';

@Injectable({
	providedIn: 'root',
})
export class ImageCropperService {
	imageChangedEvent;
	imageCropped;
	imageCropperAspect: number;
	imageCropperHeader: string;
	imageCropperId: number;
	imageCropperMinHeight: number;
	imageCropperMinWidth: number;
	imageCropperMaxHeight: number;
	imageCropperMaxWidth: number;
	imageCropperSrc: string;
	imageCropperType: string;
	imageDimensionDetail: string;
	saving: boolean;
	showImageCropper: boolean;

	showImageCropperSubscription: Subject<boolean> = new Subject<boolean>();
	imageCroppingComplete: Subject<number> = new Subject<number>();

	timestamp = moment().valueOf();

	constructor(private venueSvc: OOVenueService, private focuslink: FocuslinkService, private msgSvc: MessageService) {}

	closeImageCropper() {
		// imageCropperFileInput.nativeElement.value = '';
		this.showImageCropper = false;
		this.imageChangedEvent = null;
		this.imageCropped = null;
		this.imageCropperId = null;
		this.imageCropperSrc = '';
		this.showImageCropperSubscription.next(false);
		this.imageCroppingComplete.next(new Date().getTime());
	}

	onImageCropped(event: ImageCroppedEvent) {
		this.imageCropped = event.base64;
	}

	onImageFileChange(event: any): void {
		this.imageChangedEvent = event;
	}

	openImageCropper(type, id?, venueKey?: number) {
		this.imageCropperId = id;
		this.imageCropperType = type;
		this.imageCropperHeader = 'Edit Image';
		this.imageCropperAspect = null;
		this.imageCropperSrc = '';
		if (this.imageCropperType === 'menuitem') {
			this.imageCropperHeader = 'Edit Image: ' + id;
			this.imageCropperAspect = 16 / 9;
			this.imageCropperMinHeight = 800;
			this.imageCropperMinWidth = 1400;
			this.imageDimensionDetail = '16:9 aspect ratio. 1400px minimum width. 800px minimum height.';
			this.imageCropperSrc = `https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/${
				venueKey || this.venueSvc.subscriptionVenue.value.key
			}/${id}.png?${this.timestamp}`;
		}
		if (this.imageCropperType === 'logo') {
			this.imageCropperHeader = 'Edit Logo';
			this.imageCropperAspect = 16 / 9;
			this.imageCropperMinHeight = 800;
			this.imageCropperMinWidth = 1400;
			this.imageDimensionDetail = '16:9 aspect ratio. 1400px minimum width. 800px minimum height.';
			this.imageCropperSrc = `https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/${venueKey || this.venueSvc.venueKey}/logo.png?${
				this.timestamp
			}`;
		}
		if (this.imageCropperType === 'default') {
			this.imageCropperHeader = 'Edit Default Image';
			this.imageCropperAspect = 16 / 9;
			this.imageCropperMinHeight = 800;
			this.imageCropperMinWidth = 1400;
			this.imageDimensionDetail = '16:9 aspect ratio. 1400px minimum width. 800px minimum height.';
			this.imageCropperSrc = `https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/${venueKey || this.venueSvc.venueKey}/default.png?${
				this.timestamp
			}`;
		}
		if (this.imageCropperType === 'egiftLogo') {
			this.imageCropperHeader = 'EGift Web Page Header Image';
			this.imageCropperAspect = 16 / 9;
			this.imageCropperMinHeight = 800;
			this.imageCropperMinWidth = 1400;
			this.imageDimensionDetail = '16:9 aspect ratio. 1400px minimum width. 800px minimum height.';
			this.imageCropperSrc = `https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/${venueKey || this.venueSvc.venueKey}/egift-logo.png?${
				this.timestamp
			}`;
		}
		if (this.imageCropperType === 'egiftEmailLogo') {
			this.imageCropperHeader = 'EGIft Email Header Image';
			this.imageCropperAspect = 16 / 9;
			this.imageCropperMinHeight = 800;
			this.imageCropperMinWidth = 1400;
			this.imageDimensionDetail = '16:9 aspect ratio. 1400px minimum width. 800px minimum height.';
			this.imageCropperSrc = `https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/${venueKey || this.venueSvc.venueKey}/egift-email-logo.png?${
				this.timestamp
			}`;
		}
		if (this.imageCropperType === 'promo') {
			this.imageCropperHeader = 'Edit Promo Image';
			this.imageDimensionDetail = '1:1 A/R (500x500 suggested). JPEG or PNG.';
			this.imageCropperAspect = 1 / 1;
			this.imageCropperSrc = `https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/${venueKey || this.venueSvc.venueKey}/promo.png?${
				this.timestamp
			}`;
		}
		if (this.imageCropperType === 'canvas') {
			this.imageCropperHeader = `Edit Canvas Image: ${id}`;
			this.imageCropperAspect = 16 / 9;
			this.imageCropperMinHeight = 800;
			this.imageCropperMinWidth = 1400;
			this.imageDimensionDetail = '16:9 aspect ratio. 1400px minimum width. 800px minimum height.';
			this.imageCropperSrc = `https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/${venueKey || this.venueSvc.venueKey}/canvas-${id}.png?${
				this.timestamp
			}`;
		}
		if (this.imageCropperType === 'walletStrip') {
			this.imageCropperHeader = `Edit Apple Wallet Background Image`;
			this.imageDimensionDetail = '3:1 A/R (300x100 suggested). JPEG or PNG.';
			this.imageCropperAspect = 4 / 1;
			this.imageCropperSrc = `https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/${venueKey || this.venueSvc.venueKey}/wallet/strip.png?${
				this.timestamp
			}`;
		}
		if (this.imageCropperType === 'walletThumbnail') {
			this.imageCropperHeader = `Edit Apple Wallet Thumbnail Image`;
			this.imageDimensionDetail = '1:1 A/R (500x500 suggested). JPEG or PNG.';
			this.imageCropperAspect = 1 / 1;
			this.imageCropperSrc = `https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/${venueKey || this.venueSvc.venueKey}/wallet/thumbnail.png?${
				this.timestamp
			}`;
		}
		if (this.imageCropperType === 'walletLogo') {
			this.imageCropperHeader = `Edit Apple Wallet Logo Image`;
			this.imageDimensionDetail = '1:1 A/R (500x500 suggested). JPEG or PNG.';
			this.imageCropperAspect = 1 / 1;
			this.imageCropperSrc = `https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/${venueKey || this.venueSvc.venueKey}/wallet/logo.png?${
				this.timestamp
			}`;
		}
		if (this.imageCropperType === 'walletIcon') {
			this.imageCropperHeader = `Edit Apple Wallet Icon Image`;
			this.imageDimensionDetail = '1:1 A/R (500x500 suggested). JPEG or PNG.';
			this.imageCropperAspect = 1 / 1;
			this.imageCropperSrc = `https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/${venueKey || this.venueSvc.venueKey}/wallet/icon.png?${
				this.timestamp
			}`;
		}
		if (this.imageCropperType === 'onPrintedReceiptLogo') {
			this.imageCropperHeader = `On Receipt Logo`;
			this.imageDimensionDetail = '1:1 A/R (500x500 suggested). JPEG or PNG.';
			this.imageCropperAspect = 1 / 1;
			this.imageCropperSrc = `https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/${venueKey || this.venueSvc.venueKey}/on-receipt-logo.png?${
				this.timestamp
			}`;
		}
		if (!this.imageCropperSrc) {
			this.imageCropperSrc = this.imageCropperSrc + '?' + new Date().getTime();
		}
		this.showImageCropperSubscription.next(true);
		this.showImageCropper = true;
	}

	async saveImage(image: string, venueKey?: number) {
		this.saving = true;
		try {
			if (this.imageCropperType === 'menuitem') {
				await this.focuslink.saveOOMenuItemImage(venueKey || this.venueSvc.venueKey, this.imageCropperId, image);
			}
			if (this.imageCropperType === 'canvas') {
				await this.focuslink.saveOOCanvasImage(venueKey || this.venueSvc.venueKey, this.imageCropperId, image);
			}
			if (this.imageCropperType === 'logo') {
				await this.focuslink.saveOOVenueLogo(venueKey || this.venueSvc.venueKey, image);
				this.updateTimestamp();
			}
			if (this.imageCropperType === 'default') {
				await this.focuslink.saveOODefaultImage(venueKey || this.venueSvc.venueKey, image);
				this.updateTimestamp();
			}
			if (this.imageCropperType === 'egiftLogo' || this.imageCropperType === 'egiftEmailLogo') {
				await this.focuslink.saveOOEgiftLogoImage(venueKey || this.venueSvc.venueKey, image, this.imageCropperType);
				this.updateTimestamp();
			}
			if (this.imageCropperType === 'promo') {
				await this.focuslink.promoImagePost(venueKey || this.venueSvc.venueKey, image);
				this.updateTimestamp();
			}
			if (this.imageCropperType.includes('wallet')) {
				await this.focuslink.saveWalletImage(venueKey || this.venueSvc.venueKey, this.imageCropperType, image);
				this.updateTimestamp();
			}
			if (this.imageCropperType.includes('onPrintedReceiptLogo')) {
				await this.focuslink.saveOnReceiptImage(venueKey || this.venueSvc.venueKey, image);
			}
			this.saving = false;
			this.msgSvc.add({ severity: 'success', detail: 'Image saved' });
			this.closeImageCropper();
		} catch (error) {
			this.msgSvc.add({ severity: 'error', detail: 'Error saving image' });
			this.saving = false;
		}
	}

	updateTimestamp() {
		this.timestamp = new Date().getTime();
	}
}
